import { useState } from "react";
import { CalendarClock } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const when = (d) => (d > 0 ? `${d / 7} weeks before` : d === 0 ? "Launch day" : `${-d / 7} weeks after`);

export const LaunchPlanner = ({ p, onChange }) => {
  const [date, setDate] = useState(p?.date || "");
  if (!p) return null;
  const save = async (v) => {
    setDate(v);
    try {
      const { data } = await api.put("/me/launch-date", { date: v });
      onChange(data);
      toast.success(v ? "Launch date saved" : "Launch date cleared");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-5 rounded-xl bg-white text-navy p-5" data-testid="launch-planner">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
        <div>
          <div className="font-serif text-lg flex items-center gap-2"><CalendarClock className="h-5 w-5 text-pinkb" />Your launch countdown</div>
          <p className="text-xs text-muted-foreground mt-1">Opening a new restaurant, or launching a new menu, refurb, hours or event night? Set your date and follow the timeline.</p>
        </div>
        <label className="flex items-center gap-2 text-sm">Launch date
          <input type="date" value={date} onChange={(e) => save(e.target.value)} data-testid="launch-date-input" className="h-9 rounded-md border border-input bg-white px-2 text-sm" />
        </label>
      </div>
      {p.date && <p className="mb-4 text-sm" data-testid="launch-countdown"><span className="font-serif text-3xl text-pinkb mr-2">{Math.abs(p.days_until)}</span>{p.days_until >= 0 ? `day${p.days_until === 1 ? "" : "s"} to launch` : "days since launch"}</p>}
      <ol className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {p.timeline.map((t, i) => {
          const now = p.current_phase === i;
          const past = p.current_phase !== null && i < p.current_phase;
          return (
            <li key={t.title} data-testid={`launch-phase-${i}`} className={`rounded-lg border p-3 ${now ? "border-pinkb bg-pinkb/5" : past ? "border-border opacity-60" : "border-border"}`}>
              <div className="text-[10px] font-mono uppercase text-muted-foreground">{when(t.days_before)}{now && <span className="ml-2 text-pinkb" data-testid="launch-phase-now">· You are here</span>}</div>
              <div className="font-medium text-sm mt-1">{t.title}</div>
              <ul className="mt-2 space-y-1 text-xs text-muted-foreground list-disc pl-4">{t.tasks.map((x) => <li key={x}>{x}</li>)}</ul>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
